/**
 * @generated SignedSource<<32418de9909bc0d81b9b3cce8d8fbf30>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpHistory_nftItemHistory$data = {
  readonly events: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"NftPdpHistoryItem_nftItemHistoryEvent">;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
  } | null;
  readonly " $fragmentType": "NftPdpHistory_nftItemHistory";
};
export type NftPdpHistory_nftItemHistory$key = {
  readonly " $data"?: NftPdpHistory_nftItemHistory$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpHistory_nftItemHistory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 6,
      "kind": "LocalArgument",
      "name": "itemCount"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "itemCount",
        "cursor": "after",
        "direction": "forward",
        "path": [
          "events"
        ]
      }
    ]
  },
  "name": "NftPdpHistory_nftItemHistory",
  "selections": [
    {
      "alias": "events",
      "args": null,
      "concreteType": "NftItemHistoryEventsConnection",
      "kind": "LinkedField",
      "name": "__NftPdpHistory_events_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NftItemHistoryEventsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NftPdpHistoryItem_nftItemHistoryEvent"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItemHistory",
  "abstractKey": null
};

(node as any).hash = "628633102ae3c177a2c50c09d9131e21";

export default node;
